<template>
  <div id="seal">
    <!-- <h3>破产案例</h3> -->
    <el-card class="index">
      <div class="menu">
        <el-menu
          :default-active="$route.name"
          :key="key"
          class="el-menu-demo"
          mode="horizontal"
          @select="SelectMenu"
        >
          <el-menu-item
            v-for="(item, index) in targetRoutes"
            :key="index"
            :index="item.path"
          >
            {{ item.meta.title }}
          </el-menu-item>
        </el-menu>
      </div>
      <div class="btn">
        <el-button type="success"  @click="uploadCase" v-if="$store.state.rolesname.includes('other_case_export')">导入案件</el-button>
        <el-button type="success"  @click="uploadAdviser" v-if="$store.state.rolesname.includes('other_adviser_export')">导入顾问</el-button>
      <el-button type="success"   @click="uploadFile" v-if="$store.state.rolesname.includes('upload_file')">上传手册</el-button>
      </div>
   
      <!-- 折腾跳转是出现的文字 -->
      <!-- <div class="kb"></div>
      <div class="xian"></div> -->
      <router-view @value="getvalue"></router-view>
    </el-card>
    <!-- <router-view v-else @value="getvalue"></router-view> -->

    <el-dialog
      center
      title="操作手册上传"
      :visible.sync="isUpload"
      append-to-body
      class="file-dialog"
      width="550px"
      @close="closDialog"
    >
      <el-form class="form" ref="formRef" :model="form" label-width="150px"   :rules="formRules">
        <el-form-item label="操作手册" prop="handbook">
                    <el-upload
                      class="upload_file"
                      ref="upload"
                      v-model="form.handbook"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=操作手册"
                     
                      :auto-upload="false"
                      :on-success="uploadSuccess"
                      :multiple="false"
                      :before-upload="beforeUpload"
                      :on-before-submit="handleBeforeSubmit"
                      :limit="1"
                      :on-exceed="handleExceed">
                      <el-button size="small" class="fjchoose">请选择文件</el-button>
                    </el-upload>
                  </el-form-item>
      </el-form>
      <div class="printenter">
        <el-button type="primary" @click="printEnter('formRef')">确定上传</el-button>
      </div>
    </el-dialog>

    <el-dialog
      center
      :title="diatitle"
      :visible.sync="dialogCase"
      append-to-body
      class="file-dialog"
      width="550px"
      @close="closDialog1"
    >
      <el-form class="form" ref="formRef" :model="form" label-width="150px"   :rules="formRules">
        <el-form-item label="" prop="handbook">
                    <el-upload
                      class="upload_file"
                      ref="upload1"
                      :action="actionUrl"
                      accept=".xls,.xlsx"
                      :auto-upload="false"
                      :on-success="uploadSuccess1"
                      :multiple="false"
                      :on-before-submit="handleBeforeSubmit"
                      :limit="1"
                      >
                      <el-button size="small" class="fjchoose">请选择文件</el-button>
                    </el-upload>
                  </el-form-item>
      </el-form>
      <div class="printenter">
        <el-button type="primary" @click="printEnter1('formRef')">确定上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { getmenu, changerouter } from '../../utils/seal.js'
import {UploadHandbook} from  '../../api/set.js'
export default {
  name: 'seal',
  data() {
    return {
      next: false,
      active: '',
      array: getmenu(),
      isUpload:false,
      form:{
        handbook:''
      },
      formRules:{
        handbook: { required: true, message: '不能为空 ', trigger: 'change' },
      },
      FileList:[],
      diatitle:'',
      dialogCase:false,
      actionUrl:'',
    }
  },
  methods: {
    uploadAdviser(){
      this.actionUrl = '/api/Pc/Option/AdviserExport'
      this.diatitle = "导入顾问"
      this.dialogCase=true
    },
    uploadCase(){
      this.actionUrl = '/api/Pc/Option/CaseExport'
      this.diatitle = "导入案件"
      this.dialogCase=true
    },
    uploadSuccess1(res, file, fileList, type) {
    
      if (res.status == 'success') {
        this.$message.success(res.message)
        this.dialogCase=false
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }else{
        this.$message.error(res.message)
        this.$refs.upload1.clearFiles()
      }
    },
    //确定上传
    printEnter1(){
      this.$refs.upload1.submit()
    },
    closDialog1(){
       this.$refs.upload1.clearFiles()
    },
    //确定上传
    printEnter(formref){
      this.$refs.upload.submit()
    },
    handleExceed(files, fileList) {
      // 处理超过限制的文件数的逻辑
      this.$message.error('只能上传一个文件');
      this.uploadTips = null;
      return false;
    },
    handleBeforeSubmit() {
      if (!this.form.handbook) {
        // 如果没有选择文件，给出提示
        this.$message.warning('请先选择文件！');
        return false;
      }
      // 如果有文件，允许提交
      return true;
    },
    beforeUpload(file, type) {
     
      //上传验证
      this.uploadname = file.name
      var typefile = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      // console.log(typefile)
      var filename = file.name.substring(0, file.name.lastIndexOf('.'))
     
      const isImg =
        '.doc,.docx,.pdf,.wps,.WPS'.indexOf(
          typefile
        ) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传doc,docx,pdf,wps'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList, type) {
      //招标文件上传成功
      // var fileid = this.FileList1.map(item => Object.assign({}, { 'id': item.id }));
      // console.log(file)
      if (res.status == '0') {
       
        var c = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
        console.log(c)
        UploadHandbook({fileId:c}).then((res)=>{
          if(res.data.status=='success'){
            this.$refs.upload.clearFiles()
            this.isUpload=false
            
            this.$message.success('上传成功')
          }else{
            this.$refs.upload.clearFiles()
            this.isUpload=false
            this.$message.error('上传失败')
          }
        })
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
    },
    SelectMenu(item) {
      console.log(this.$route)
      this.$router.push({
        query: {
          guid: this.$route.query.guid,
          type: this.$route.query.type
        },
        path: item
      })
    },
    getvalue(value) {
      //获取子组件的值
      this.next = value
      // console.log("成功"+value);
    },
    //手册上传点击按钮
    uploadFile(){
      this.isUpload=true
    },
    closDialog(){
       this.$refs.upload.clearFiles()
    }
  },
  created() {
    // console.log('addrouters',this.$store.state.permission.addRoutes);
  },
  computed: {
    key() {
      if (this.$route.meta.menu == 'Sealdetail') {
        return 'Sealdetail'
      } else if (this.$route.meta.menu == 'Biddetail') {
        return 'Biddetail'
      } else if (this.next) {
        return 'sealApply'
      }
    },
    targetRoutes() {
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/set' //遍历每一个数组，过滤出返回值委true的值
      )
      let arr = target[0].children
      if (this.next) {
        arr = arr.filter((el) => el.hidden == true && el.meta.menu == 'detail')
      } else {
        arr = arr.filter((el) => el.hidden != true)
      }
      // console.log(arr)
      return arr
    }
  },
  watch: {}
}
</script>
  
<style lang="less" scoped>
#seal .index {
  width: 100%;
  margin: auto;
  border-radius: 16px;
  position: relative;
}

#seal .el-menu {
  display: flex;
  text-align: center;
  border-right: 0px;
  // margin-bottom: 5vh;
  // .el-menu-item{
  //   width:20vh;
  // }

  .el-menu-item {
    font-size: 16px;
    height: 55px;

    &:hover {
      background-color: #fff;
      color: #409eff !important;
      border-bottom: 1px solid #409eff;
    }
  }

  .el-menu-item.is-active {
    background-color: #fff !important;
    border-bottom: 1px solid #409eff;
    color: #409eff !important;
  }
}

#seal .el-menu.el-menu--horizontal {
  border-bottom: none;
}

#seal .menu {
  width: 96%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#seal /deep/.el-card__body,
#seal .el-main {
  padding: 0px;
  padding-bottom: 20px;
}

#seal .xian {
  width: 100%;
  border-bottom: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 24px;
}

#seal .btn {
  position: absolute;
  top: 8px;
  right: 2%;
  z-index: 2;
  // position:absolute;
  // top:130px;
  // right: 2%;
}

#seal .kb {
  width: 98px;
  height: 47px;
  position: absolute;
  top: 8px;
  right: 2%;
  background: #fff;
  z-index: 1;
}
//附件回显
.upload_file {
  width: 365px;
}
.printenter {
  text-align: center;
  padding-top: 10%;
}
</style>
  